module.exports = __webpack_public_path__ + "static/media/Tropius_gaussian2.ab6201dd.png";